<template>
	<div class="vue-offer-theme">
		<div class="vue-offer-theme-header" v-if="!isSample">
			<div class="alert alert-outline-success" role="alert">
				<div class="alert-icon"><i class="fas fa-info-circle"></i></div>
				<div class="alert-content">
					<div class="alert-content-text">
						Quick access Sales Box Theme Library
					</div>
					<div class="alert-content-button">
						<button class="btn btn-secondary" :class="{ 'is-loading' : modal.is_loading }" @click.stop.prevent="showModalTemplate">
							Select Theme 
						</button>
					</div>
				</div>
			</div>
		</div>
		<transition name="fade" mode="out-in">
			<div class="pd-30" v-if="is_change" key="is-change">
				<div class="spinner-border text-primary" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
			<div class="vue-offer-theme-body" v-else key="is-change-success">
				<div class="row m-t-25">
					<div class="col col-4">
						<label>
							Background
						</label>
					</div>
					<div class="col col-8">
						<div class="row">
							<div class="col col-6">
								<label class="m-b-5">
									<input type="radio" v-model="form.theme_setting.config.background_type" value="solid"><strong>Solid background</strong>
								</label>
								<vue-colorpicker  
								:class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-background-color')}" 
								:disabled="form.theme_setting.config.background_type != 'solid'" 
								v-model="form.theme_setting.style['--salesbox-background-color']"></vue-colorpicker>
							</div>
						</div>
						<div class="row m-t-15">
							<div class="col col-6">
								<label class="m-b-5">
									<input type="radio"  v-model="form.theme_setting.config.background_type" value="pattern"><strong>Pattern background</strong>
								</label>
								<vue-parttern :class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-background-pattern')}"   :disabled="form.theme_setting.config.background_type != 'pattern'" v-model="form.theme_setting.style['--salesbox-background-pattern']"></vue-parttern>
							</div>
							<div class="col col-6">
								<label class="m-b-5">
									Pattern position
								</label>
								<vue-select :disabled="form.theme_setting.config.background_type != 'pattern'" v-model="form.theme_setting.style['--salesbox-background-pattern-position']" :options="background_position"  />
							</div>
						</div>
						<!-- <div class="row  m-t-15">
							<div class="col col-6">
								<label class="m-b-5">
									<input type="radio"   v-model="form.theme_setting.config.background_type" value="image"><strong >Image background</strong>
								</label>
								<button :class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-background-image')}" class="btn btn-secondary btn-block " @click="showModal"  :disabled="form.theme_setting.config.background_type != 'image'">Add Images</button>
							</div>
							<div class="col col-6">
								<label class="m-b-5">
									Image position
								</label>
								<vue-select :disabled="form.theme_setting.config.background_type != 'image'" v-model="form.theme_setting.style['--salesbox-background-image-position']" :options="background_position"  />
							</div>
						</div> -->
					</div>
				</div>
				<div class="row m-t-15">
					<div class="col col-4">
						<label>
							Background Style
						</label>
					</div>
					<div class="col col-8">
						<div class="row">
							<div class="col col-6">
								<label>Corner Radius</label>
								<vue-select   v-model="form.theme_setting.style['--salesbox-border-radius']" class="vue-select-border-style" :options="border_radius" placeholder="Select corner"></vue-select>
							</div>
							<div class="col col-6">
								<label>
									<input type="checkbox" v-model="form.theme_setting.config.show_box_shadow"><strong>Show box shadow</strong>
								</label>
							</div>
						</div>
						
					</div>
				</div>
				<div class="row m-t-15">
					<div class="col col-4">
						<label>
							<input type="checkbox"  v-model="form.theme_setting.config.show_border"><strong>Show Border</strong>
						</label>
					</div>
					<div class="col col-8">
						<div class="row">
							<div class="col col-6 ">
								<label>Border Style</label>
								<vue-select  :disabled="!form.theme_setting.config.show_border" v-model="form.theme_setting.style['--salesbox-border-style']" class="vue-select-border-style" :options="border_styles" placeholder="Select style">
									<template slot="selected" slot-scope="selected">
										<div class="item-selected" :class="`item-selected-${selected.id}`"></div>
									</template>
									<template slot="option" slot-scope="option">
										<div class="item-option" :class="`item-selected-${option.id}`"></div>
									</template>
								</vue-select>
							</div>
							<div class="col col-6 ">
								<label>Border Color</label>
								<vue-colorpicker 
								:class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-border-color')}" 
								:disabled="!form.theme_setting.config.show_border" 
								v-model="form.theme_setting.style['--salesbox-border-color']"></vue-colorpicker>
							</div>
							<div class="col col-6 m-t-15">
								<label>Line width</label>
								<vue-select  :disabled="!form.theme_setting.config.show_border" v-model="form.theme_setting.style['--salesbox-border-width']" class="vue-select-border-style" :options="border_widths" placeholder="Select style"></vue-select>
							</div>
						</div>
					</div>
				</div>
				
				<hr>
				<div class="row">
					<div class="col col-4">
						<label>
							Text Style
						</label>
					</div>
					<div class="col col-8">
						<div class="row ">
							<div class="col col-6">
								<label>Text Font</label>
								<vue-select  v-model="form.theme_setting.style['--salesbox-font-family']" class="vue-select-font-family" :options="font_family" placeholder="Select font">
									<template slot="selected" slot-scope="selected">
										<div class="item-selected" :style="{ fontFamily:  selected.id }">{{selected.name}}</div>
									</template>
									<template slot="option" slot-scope="option">
										<div class="item-option" :style="{ fontFamily:  option.id }">{{option.name}}</div>
									</template>
								</vue-select>
							</div>
						</div>
						<div class="row m-t-15">
							<div class="col col-6">
								<label>Label Text Font Size</label>
								<vue-select   v-model="form.theme_setting.style['--salesbox-label-font-size']" class="vue-select-border-style" :options="font_size" placeholder="Select font size"></vue-select>
							</div>
							<div class="col col-6">
								<label>Label Text Color</label>
								<vue-colorpicker  
								:class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-label-color')}" 
								v-model="form.theme_setting.style['--salesbox-label-color']"></vue-colorpicker>
							</div>
						</div>
						<div class="row m-t-15">
							<div class="col col-6">
								<label>Main Text Font Size</label>
								<vue-select   v-model="form.theme_setting.style['--salesbox-font-size']" class="vue-select-border-style" :options="font_size" placeholder="Select font size"></vue-select>
							</div>
							<div class="col col-6">
								<label>Main Text Color</label>
								<vue-colorpicker   
								:class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-color')}" 
								v-model="form.theme_setting.style['--salesbox-color']"></vue-colorpicker>
							</div>
						</div>
						<div class="row m-t-15">
							<div class="col col-6">
								<label>Value Text Font Size</label>
								<vue-select   v-model="form.theme_setting.style['--salesbox-shortcode-font-size']" class="vue-select-border-style" :options="font_size" placeholder="Select font size"></vue-select>
							</div>
							<div class="col col-6">
								<label>Value Text Color</label>
								<vue-colorpicker  
								:class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-shortcode-color')}" 
								v-model="form.theme_setting.style['--salesbox-shortcode-color']"></vue-colorpicker>
							</div>
						</div>
					</div>
				</div>
				<div class="row m-t-15">
					<div class="col col-4">
						<label>
							Hyperlink Text Effect
						</label>
					</div>
					<div class="col col-8">
						<div class="row">
							<div class="col col-6 ">
								<label>
									<input type="checkbox" v-model="form.theme_setting.config.link_underline"><strong>Text Underline</strong>
								</label>
							</div>
							<div class="col col-6">
								<label>
									<input type="checkbox" v-model="form.theme_setting.config.link_hover"><strong>Change color on hover</strong>
								</label>
								<vue-colorpicker 
								:class="{ 'is-invalid is-invalid-scroll-to' : isValid('--salesbox-link-color-hover')}" 
								:disabled="!form.theme_setting.config.link_hover" 
								v-model="form.theme_setting.style['--salesbox-link-color-hover']"></vue-colorpicker>
							</div>
						</div>
						
					</div>
				</div>
				<hr>
				<div class="row">
					<div class="col col-4">
						<label>
							<input type="checkbox"  v-model="form.is_custom_css"><strong>CSS Styling</strong>
						</label>
					</div>
					<div class="col col-8">
						<div class="vue-offer-theme-code" v-if="form.is_custom_css">
							<codemirror v-model="form.custom_css" :options="cm_options"></codemirror>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<vue-cropper v-model="show_modal_cropper" @on-crop="onCropImage"></vue-cropper>
		<vue-modal class="modal-theme" width="900px" v-model="modal.show" @on-hide="onHideModal">
			<template slot="modal-header">
				<div class="modal-header-container">
					<h5>Select a Theme</h5>
				</div>
			</template>
			<template slot="modal-body">
				<simplebar class="modal-body-container">
					<div class="list-item-theme">
						<div class="row" >
							<div class="col col-6 m-b-30" v-for="(item, index) in modal.data" :key="`index_item_${index}`">
								<div class="item-theme"  @click.stop.prevent="onSelect(item)" :class="{ 'is-active' : modal.selected && modal.selected.id == item.id}">
									<offer-preview  :message="defaultData.message" :theme="item.data.theme_setting" ></offer-preview>
								</div>
							</div>
						</div>
					</div>
				</simplebar>
			</template>
			<template slot="modal-footer">
				<div class="modal-footer-container">
					<button class="btn btn-secondary" @click="modal.show = false">Cancel</button>
					<button class="btn btn-primary" @click="onSave()" :disabled="modal.selected == null">Apply</button>
				</div>
			</template>
		</vue-modal>
	</div>
</template>
<script>
import VueColorpicker from '@/components/vue-colorpicker'
import VueSelect from '@/components/vue-select'
import VueParttern from '@/components/vue-parttern'
import VueCropper from '@/components/vue-cropper'
import VueModal from '@/components/vue-modal'
import OfferPreview from './offer-preview'
import 'codemirror/mode/css/css.js'
import { mapGetters , mapActions  } from 'vuex'
export default {
	name : 'OfferTheme',
	components:{
		VueColorpicker,
		VueSelect,
		VueParttern,
		VueCropper,
		VueModal,
		OfferPreview
	},
	props:{
		value :{
			type : Object,
			required : true,
		},
		formstate :{
			type : Boolean,
			required : true,
		},
		validate :{
			type : Object,
			required : true,
		},
		isSample : {
			type : Boolean,
			default : false,
		}
	},
	data(){
		return {
			show_modal: false,
			allow_modal_backdrop: true,
			border_styles : [
				{
					id: "solid",
				}, {
					id: "dotted",
				}, {
					id: "double",
				}, {
					id: "dashed",
				}
			],
			border_widths: [
				{
					id : "1px",
					name : "1px",
				},
				{
					id: "2px",
					name: "2px"
				},
				{
					id: "3px",
					name: "3px"
				},
				{
					id: "4px",
					name: "4px"
				},
				{
					id: "5px",
					name: "5px"
				}
			],
			border_radius:[
				{
					id : "none",
					name : "None",
				},
				{
					id : "1px",
					name : "1px",
				},
				{
					id: "2px",
					name: "2px"
				},
				{
					id: "3px",
					name: "3px"
				},
				{
					id: "4px",
					name: "4px"
				},
				{
					id: "5px",
					name: "5px"
				},
			],
			font_family : [
				{
					id : 'inherit',
					name : 'Shop font'
				},
				{
					id : 'Nunito',
					name : 'Nunito'
				},
				{
					id : 'Nunito Sans',
					name : 'Nunito Sans'
				},
				{
					id : 'Montserrat',
					name : 'Montserrat'
				},
				{
					id : 'Libre Baskerville',
					name : 'Libre Baskerville'
				},
				{
					id : 'Ubuntu',
					name : 'Ubuntu'
				},
				{
					id : 'IBM Plex Sans',
					name : 'IBM Plex Sans'
				},
				{
					id : 'Zilla Slab',
					name : 'Zilla Slab'
				},
				{
					id : 'Playfair Display',
					name : 'Playfair Display'
				},
				{
					id : 'Podkova',
					name : 'Podkova'
				},
				{
					id : 'Frank Ruhl Libre',
					name : 'Frank Ruhl Libre'
				},
				{
					id : 'Aleo',
					name : 'Aleo'
				},
				{
					id : 'Poppins',
					name : 'Poppins'
				},
				{
					id : 'Josefin Sans',
					name : 'Josefin Sans'
				},
				{
					id : 'Open Sans',
					name : 'Open Sans'
				},
				{
					id : 'Lato',
					name : 'Lato'
				},
			],
			font_size:[
				{
					id : "inherit",
					name : "inherit",
				},
				{
					id : "10px",
					name : "10px",
				},
				{
					id: "11px",
					name: "11px"
				},
				{
					id: "12px",
					name: "12px"
				},
				{
					id: "13px",
					name: "13px"
				},
				{
					id: "14px",
					name: "14px"
				},
				{
					id: "15px",
					name: "15px"
				},
				{
					id: "16px",
					name: "16px"
				},
				{
					id: "17px",
					name: "17px"
				},
				{
					id: "18px",
					name: "18px"
				},
				{
					id: "19px",
					name: "19px"
				},
				{
					id : "20px",
					name : "20px",
				},
				{
					id : "21px",
					name : "21px",
				},
				{
					id : "22px",
					name : "22px",
				},
				{
					id : "23px",
					name : "23px",
				},
				{
					id : "24px",
					name : "24px",
				},
				{
					id : "25px",
					name : "25px",
				},
				{
					id : "26px",
					name : "26px",
				},
				{
					id : "27px",
					name : "27px",
				},
				{
					id : "28px",
					name : "28px",
				},
				{
					id : "29px",
					name : "29px",
				},
				{
					id : "30px",
					name : "30px",
				},
			],
			background_position : [
				{
					id : 'center top',
					name : 'Top'
				},
				{
					id : 'center center',
					name : 'Middle'
				},
				{
					id : 'center bottom',
					name : 'Bottom'
				},
			],
			cm_options: {
				mode: 'text/css',
				lineNumbers: false,
			},
			show_modal_cropper : false,
			is_change: false,
			modal :{
				is_loading : false,
				selected : null ,
				data: [],
				show : false,
			}
		}
	},
	computed:{
		form :{
			get(){
				return this.value
			},
			set(value){
				this.$emit('input', value)
			}
		},
		...mapGetters({
			country: 'country/getCountry',
			defaultData : 'offer/getDefaultData'
		})
	},
	methods:{
		...mapActions({
			get : 'setting/getSample',
			
		}),
		isValid(style){
			if( this.formstate ){
				return this.validate.theme_setting.style[style].$invalid
			}
			return false
		},
		hideModal(){
			this.show_modal_cropper = false 
		},
		showModal() {
			this.show_modal_cropper = true
		},
		onCropImage(base64){
			this.form.theme_setting.style['--salesbox-background-image'] = base64
			this.form.background_image_base64 =base64
		},
		onHideModal(){
			this.modal = {
				is_loading : false,
				selected : null ,
				data: [],
				show : false,
			}
		},
		showModalTemplate(){
			if( this.modal.is_loading ) return 
			this.modal.is_loading = true 
			this.get({type : 'theme'}).then((res)=>{
				let { status , data = null } = res.data 
				if( status  && data){
					this.modal.data = data 
					this.modal.show = true
				}else{
					this.$toast({
						title: "Warning !",
						message: 'No theme template found',
						icon: "fad fa-exclamation-circle",
						type: 'danger',
						time : 2000,
					});
				}
			})
			.finally(()=>{
				this.modal.is_loading = false 
			})
		},
		onSelect(item){
			var item = this.$clone(item)
			if( this.modal.selected ){
				if( this.modal.selected.id == item.id ){
					this.modal.selected = null 
				}else{
					this.modal.selected = item 
				}
			}else{
				this.modal.selected = item 
			}
		},
		onSave(){
			this.$confirm.show({
				title : 'Are you sure?',
				content : 'Do you want to replace your current theme with the selected one?',
				contentType : 'text',
				btnClose : 'Cancel',
				btnCloseClass : 'btn btn-secondary',
				onClose : null ,
				btnSave : 'Replace',
				btnSaveClass : 'btn btn-primary',
  				onSave:  ()=>{
  					return new Promise( (resolve, reject)=>{
						this.is_change = true 
						this.$nextTick(()=>{
							this.form.theme_setting = Object.assign(this.form.theme_setting , this.modal.selected.data.theme_setting)
							this.form.background_image_base64 = ''
							this.modal.show = false
							this.is_change = false 
						})
						
  						resolve();
  					});
  				}
			})
		}
	},
}
</script>
<style lang="scss" scoped>
	
	.vue-offer-theme{
		hr{
			border-top: 1px solid #F0F0F0;
			margin: 25px 0;
		}
		&-header{
			.alert{
				flex-wrap: nowrap;
				&-content{
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					@include flex(calc(100% - 37px));
					&-text{
						@include col;
						align-items: center;
						display: flex;
					}
					&-button{
						@include flex(150px);
						.btn{
							width: 100%;
						}
					}
				}
			}
		}
		&-body{
			label{
				font-weight: bold;
				font-size: 13px;
				line-height: 18px;
				&.normal{
					font-weight: normal;
				}
			}
			.vue-offer-theme-code{
				&[disabled]{
					opacity: 0.5;
					pointer-events: none;
				}
			}
		}
	}
	.vue-select{
		&-pattern{
			.item-option ,.item-selected{
				height: 34px;
				display: block;
				
				overflow: hidden;
				img{
					width: 100%;
				}
			}
			.item-selected{
				margin-left: -8px;
			}
		}
		&-border-style {
			.item {
				&-option,
				&-selected {
					width: 100%;
					height: 3px;
					border-width: 3px 0 0 0;
					border-color: #000;
					&-solid {
						border-style: solid;
					}
					&-dotted {
						border-style: dotted;
					}
					&-double {
						border-style: double;
					}
					&-dashed {
						border-style: dashed;
					}
				}
			}
		}
		&-font-family{
			.item {
				&-option,
				&-selected {
					width: 100%;
					border-width: 2px 0 0 0;
					border-color: #000;
					&-solid {
						border-style: solid;
					}
					&-dotted {
						border-style: dotted;
					}
					&-double {
						border-style: double;
					}
					&-dashed {
						border-style: dashed;
					}
				}
			}
		}
	}
	.list-flags{

	}
	.modal-theme{
		.modal{
			&-header-container{
				padding: 15px;
				border-bottom: 1px solid #f2f2f2;
			}
			&-body-container{
				padding: 15px;
				height: 450px;
				overflow: hidden auto;
				.list-item-theme{
					.item-theme{
						cursor: pointer;
						position: relative;
						border-radius: 5px;
						padding:0px;
						border: 4px solid transparent;
						background: #F8F8F8;
						box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
						&:last-child{
							margin-bottom: 0;
						}
						&:hover ,&.is-active{
							border-color: $primary;
						}
					}
				}
			}
			&-footer-container{
				border-top: 1px solid #f2f2f2;
				padding: 6px 15px;
				text-align: right;
			}
		}
	}
</style>